module.exports = __webpack_public_path__ + "img/banner1.c26e155b.png";